import * as React from 'react';
import { ApolloError, gql } from '@apollo/client';
import { useCallback, useContext } from 'react';
import { AppContext } from '../../../../providers/AppProvider';
import { useRssOpmlUploadMutation } from '../../../../models/graphql';
import { OpmlImportModalView, OpmlImportModalViewProps } from './OpmlImportModal.view';
import { remapApolloErrors } from '../../../../helpers/remapApolloErrors';
import { showToast } from '../../../../helpers/showToast';
import { TreeMenuContext } from '../TreeMenu/TreeMenuProvider';
import { Void } from '../../../../models/basic-objects';

export type OpmlImportModalApolloProps = {
  closeHandler: Void;
};

gql`
  mutation RssOpmlUpload($workspaceId: ID!, $file: Upload!) {
    rssOpmlUpload(workspaceId: $workspaceId, file: $file) {
      importFolders {
        ...CoreImportFolderFields
      }
      importSources {
        ...ImportSourceFields
      }
    }
  }
`;

export const OpmlImportModalApollo = (props: OpmlImportModalApolloProps): JSX.Element => {
  const { closeHandler } = props;
  const { selectedWorkspaceId } = useContext(AppContext);
  const { reFetchTreeMenu } = useContext(TreeMenuContext);

  const [rssOpmlUpload, { loading: uploadLoading }] = useRssOpmlUploadMutation();

  const uploadOpmlFile = useCallback(
    (file: File) => {
      if (!selectedWorkspaceId) return;

      rssOpmlUpload({
        variables: {
          workspaceId: selectedWorkspaceId,
          file
        }
      })
        .then(() => {
          reFetchTreeMenu();
        })
        .catch(e => {
          const errorForRemapping = e as ApolloError;
          const mappedError = remapApolloErrors(errorForRemapping);
          showToast({
            summary: 'Error uploading file',
            detail: mappedError,
            severity: 'error'
          });
        })
        .finally(() => {
          closeHandler();
        });
    },
    [closeHandler, reFetchTreeMenu, rssOpmlUpload, selectedWorkspaceId]
  );

  const viewProps: OpmlImportModalViewProps = {
    ...props,
    uploadLoading,
    uploadOpmlFile
  };

  return <OpmlImportModalView {...viewProps} />;
};
